<template>
    <b-container>
        <b-row>
            <b-col>
                <h1>
                    Create a New User
                </h1>

                <b-form @submit.prevent="onSubmit">
                    <b-form-group>
                        <label>
                            Name
                        </label>
                        
                        <b-form-input
                            type="text"
                            v-model="form.name"
                            required>
                        </b-form-input>

                        <label>
                            Role
                        </label>

                        <b-form-select 
                            class="mb-2"
                            v-model="form.role" 
                            :options="role_options"
                            required>
                        </b-form-select>

                        <label>
                            Email
                        </label>
                        
                        <b-form-input
                            type="email"
                            v-model="form.email"
                            required>
                        </b-form-input>
                        <label>
                            Password
                        </label>
                        
                        <b-form-input
                            type="password"
                            v-model="form.password"
                            required>
                        </b-form-input>

                        <label>
                            Confirm Password
                        </label>
                        
                        <b-form-input
                            type="password"
                            v-model="form.password_confirmation"
                            required>
                        </b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary">
                        Submit
                    </b-button>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import userRepository from "@/repository/users";

    export default {        
        data() {
            return {
                form: {
                    name: "",
                    role: "",
                    email: "",
                    password: "",
                    password_confirmation: ""
                },
                errors:{},
                role_options: [
                    'ADMIN',
                    'CLIENT'
                ]
            }
        },

        methods: {            
            onSubmit() {
                userRepository.store(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'User Created',
                            text: 'New user successfully created.'
                        });

                        this.clear();
                    }).catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });


            },

            clear() {
                for (let field in this.form) {
                    this.form[field] = "";
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    
</style>